import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { InvitePendingDto, UserInviteDto } from '@fleet-beat/api';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyDto,
  PageableListDto,
  ResponseDto,
} from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InvitesApiService {
  private readonly baseUrl: string = `${this.environment.tenantsApiUrl}/api/invites`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  generateLinkInvite(params: UserInviteDto, auth: AuthHeaders): Observable<UserInviteDto> {
    return this.baseApiService.post(`${this.baseUrl}`, { ...params, inviteByEmail: false }, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<UserInviteDto>) => this.baseApiService.mapResponse(response)),
    );
  }

  inviteManagerWithEmail(params: UserInviteDto, auth: AuthHeaders): Observable<UserInviteDto> {
    return this.baseApiService.post(`${this.baseUrl}`, { ...params, inviteByEmail: true }, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<UserInviteDto>) => this.baseApiService.mapResponse(response)),
    );
  }

  deleteInvite(id: string, auth: AuthHeaders): Observable<UserInviteDto> {
    return this.baseApiService.delete(`${this.baseUrl}/${id}`, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<UserInviteDto>) => this.baseApiService.mapResponse(response)),
    );
  }

  getInvites(params: GetManyDto, auth: AuthHeaders): Observable<PageableListDto<InvitePendingDto>> {
    return this.baseApiService.get(`${this.baseUrl}`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<PageableListDto<InvitePendingDto>>) => this.baseApiService.mapResponse(response)),
    );
  }
}
